/**
 * OfficesPage
 *
 * This is the page we show when the user visits a url that doesn't have a route
 *
 */

import React from 'react';
import { Helmet } from 'react-helmet';
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';

import { Content, OfficesList } from './styledComponents';

const containerStyle = {
  width: '70%',
  height: '655px',
  maxHeight: '60vh',
  justifySelf: 'center',
};

const center = {
  lat: 24,
  lng: -103.91,
};

const scaledSize = { width: 40, height: 40 };
const anchor = { x: 17, y: 46 };

const itemsCuliacan = [
  {
    name: 'Campiña',
    address:
      'Prolongación Doctor Mora entre Blvd Sabinos y Eucaliptos Num. 1725, Local 1C Col. La Campiña Culiacán , Sinaloa México , C.P. 80060',
    schedule: '10:00 a 20:00',
  },
  {
    name: 'Plaza fiesta',
    address:
      'Av. Lázaro Cárdenas e Insurgentes Num. 970 Sur Col. Los Pinos Culiacán, Sinaloa México , C.P. 80128',
    schedule: '10:00 a 20:00',
  },
  {
    name: 'Sendero',
    address:
      'Calzada José Limón No. 2545 Nte. Local C18, Col. Humaya. Culiacán, Sinaloa, C.P. 80020',
    schedule: '11:00 a 21:00',
  },
  {
    name: 'Morelos',
    address:
      'José Maria Morelos Num. #481 Col. Centro Sinaloa Culiacán , Sinaloa México , C.P. 80000',
    schedule: '10:00 a 20:00',
  },
  {
    name: 'Walmart México 68',
    address:
      'Walmart Alvaro Obregon, Esq. México 68 Num. 2891 Col. Montebello Culiacán , Sinaloa México , C.P. 80227',
    schedule: '10:00 a 20:30',
  },
  {
    name: 'San Isidro',
    address:
      'Paseo de los Ganaderos No. 1787 pte. Fracc. Lomas de San Isidro, Local 23 y 24. Culiacán, Sinaloa México, C.P. 80197',
    schedule: '11:00 a 21:00',
  },
];

// const itemsMochis = [
//   {
//     name: 'Las Palmas',
//     address:
//       'Av. Alvaro Obregón y Blvd. Antonio Rosales Sin Núm. Local 15B, Plaza Fiesta Las Palmas. Col. Centro Los Mochis, Sinaloa. México, C.P. 81200',
//     schedule: '10:00 a 20:00',
//   },
//   {
//     name: 'Hidalgo centro',
//     address:
//       'Miguel Hidalgo 169 Poniente. Col. Centro Los Mochis, Sinaloa México, C.P. 81200',
//     schedule: '10:00 a 20:00',
//   },
// ];

const itemsObregon = [
  {
    name: 'Digital',
    address:
      'Carretera Internacional #1073 Local 14, Fracc. Real del Sol. Ciudad Obregón, Sonora México, C.P. 85050',
    schedule: '10:00 a 20:00',
  },
];

const itemsDurango = [
  {
    name: 'Digital',
    address:
      'Felipe Pescador #1401 Int. Local 23 y 24 Col. Victoria de Durango, Centro, Durango, Durango, C.P. 34000',
    schedule: '10:00 a 20:00',
  },
];

const itemsQueretaro = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

const itemsNavojoa = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

const itemsTor = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

const itemsGmz = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

const itemsLerdo = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

const itemsSanJuan = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

const itemsHmo = [
  {
    name: 'Digital',
    address: '',
    schedule: '',
  },
];

export default function Offices() {
  return (
    <Content>
      <Helmet>
        <title>Conoce nuestras sucursales</title>
      </Helmet>
      <h2>Contamos con 9 sucursales</h2>
      <h3>Encuentra la más cercana a tí</h3>
      <LoadScript googleMapsApiKey="AIzaSyDz1qg23l-au5a_cXwL-Awutuv-SSj7OGA">
        <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={5}>
          {/* <Marker
            id="campiña"
            position={{ lat: 24.816173, lng: -107.365726 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="plaza-fiesta"
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
            position={{ lat: 24.794528, lng: -107.410775 }}
          />
          <Marker
            id="sendero"
            position={{ lat: 24.825328, lng: -107.42665 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="morelos"
            position={{ lat: 24.808448, lng: -107.398089 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="walmart-68"
            position={{ lat: 24.778916, lng: -107.394846 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="san-isidro"
            position={{ lat: 24.755863, lng: -107.402642 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          /> */}
          {/* <Marker
            id="las-palmas"
            position={{ lat: 25.79037, lng: -109.001546 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="hidalgo-centro"
            position={{ lat: 25.808304, lng: -109.013788 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          /> */}
          <Marker
            id="cd-obregon"
            position={{ lat: 27.483922, lng: -109.933048 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          {/* <Marker
            id="cd-obregon-tutuli"
            position={{ lat: 27.492998, lng: -109.9475577 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          /> */}
          <Marker
            id="paseo-durango"
            position={{ lat: 24.025834, lng: -104.663688 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="queretaro"
            position={{ lat: 20.6147246, lng: -100.5053973 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="hermosillo"
            position={{ lat: 29.095849, lng: -110.980633 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="torreon"
            position={{ lat: 25.537287, lng: -103.404661 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="lerdo"
            position={{ lat: 25.537611, lng: -103.524817 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="gomez"
            position={{ lat: 25.58282, lng: -103.482803 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="navojoa"
            position={{ lat: 27.070874, lng: -109.445307 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
          <Marker
            id="sanjuan"
            position={{ lat: 20.3907, lng: -99.982856 }}
            icon={{
              url: './images/custom-marker.svg',
              anchor,
              scaledSize,
            }}
          />
        </GoogleMap>
      </LoadScript>
      <OfficesList>
        <div className="list">
          <div className="title">Torreón</div>
          {itemsTor.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">Gómez Palacio</div>
          {itemsGmz.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">Lerdo</div>
          {itemsLerdo.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">Navojoa</div>
          {itemsNavojoa.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">San Juan del Río</div>
          {itemsSanJuan.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          {/* <div className="title">Culiacán</div>
          {itemsCuliacan.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))} */}
        </div>
        <div className="list">
          {/* <div className="title">Los Mochis</div>
          {itemsMochis.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))} */}
          <div className="title">Ciudad Obregón</div>
          {itemsObregon.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">Durango</div>
          {itemsDurango.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">Querétaro</div>
          {itemsQueretaro.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
          <div className="title">Hermosillo</div>
          {itemsHmo.map(item => (
            <div className="item">
              <div className="name">
                <img
                  src="./images/logo-new-p.png"
                  width="40px"
                  alt="Logo PrestaVale pequeño"
                />
                {item.name}
              </div>
            </div>
          ))}
        </div>
      </OfficesList>
    </Content>
  );
}
